namespace TabAurous.Production {
    export interface JobWorkIssueBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BomProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        CalcOnId: Serenity.LookupEditor;
    }

    export class JobWorkIssueBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkIssueBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkIssueBOMForm.init)  {
                JobWorkIssueBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = CommonCategoryLookup;
                var w2 = s.LookupEditor;
                var w3 = s.StringEditor;
                var w4 = StoneSieveLookup;
                var w5 = s.DecimalEditor;
                var w6 = WeightEditor;

                Q.initFormType(JobWorkIssueBOMForm, [
                    'ItemTypeId', w0,
                    'CategoryId', w1,
                    'SubCategoryId', w2,
                    'BomProductId', w3,
                    'AttributeId', w3,
                    'ProductCode', w3,
                    'CertificateNo', w3,
                    'KaratId', w2,
                    'ShapeId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w4,
                    'GroupSieveId', w4,
                    'MetalColorId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w3,
                    'StoneDepth', w3,
                    'Lab', w2,
                    'Purity', w5,
                    'PureWeight', w5,
                    'Pieces', w0,
                    'Weight', w6,
                    'CalcOnId', w2
                ]);
            }
        }
    }
}
